import * as React from 'react';
import styled from "@emotion/styled";
import { Grid } from '@mui/material';
import Link from '@mui/material/Link';

const Heading = styled.h1`
font-family: poppins;
color: #f7931a;
font-size: 70px;
margin-bottom: 10px;
font-weight:bold;
margin-top: 0px;
width: fit-content;
text-shadow: 0px 0px 50px rgba(247, 147, 26, 1);
@media (max-width: 900px) {
    font-size: 40px;
    text-align:center;
  }
@media (max-width: 1050px) and (min-width: 901px) {
    font-size: 55px;
    margin-top:15px;
  }
@media (min-width: 1051px) {
    margin-top:25px;
  }
`
const Description = styled.p`
font-family: poppins;
color: #fff;
font-size: 18px;
margin-top: 10px;
font-weight: 400;
margin-bottom:25px;
@media (max-width: 749px){
    font-size:16px;
    text-align: center;
}
@media (max-width: 1050px) and (min-width: 749px) {
    font-size: 15px;
  }
`
const Anchors = styled(Link)`
color: #fff;
padding: 5px 10px;
background: #03A9F4;
text-decoration: unset;
font-size: 18px;
font-family: poppins;
border-radius: 36px;
margin-right: 15px;
@media (max-width: 749px){
    font-size:14px;
    margin-right:10px;
}
`
const FirstAnchor = styled(Link)`
color: #000;
padding: 5px 10px;
background: #fff;
text-decoration: unset;
font-size: 18px;
font-family: poppins;
border-radius: 36px;
margin-right: 15px;
@media (max-width: 749px){
    font-size:14px;
    margin-right:10px;
}
`
const AnchorWrapper = styled.div`
@media (max-width: 749px){
    display: flex;
    justify-content: center;
}
` 
const Tabwrapper = styled(Grid)`
padding:0px;
@media (max-width: 749px){
    padding-top:25px;
}
`
const CsIcons = styled.img`
width:13px;
height:13px;
@media (max-width: 749px){
    11px
}
`
function Home(){
    return (
        <Tabwrapper>
            <Heading>iBitcoin ($iBTC)</Heading>
            <Description>iBTC is the first ever wrapped BTC token pair on the Ethereum Network 
            that embodies the originality and innovation of Steve jobs and Satsohi Nakamoto.</Description>
            <AnchorWrapper>
                <FirstAnchor href="#"><CsIcons src='./assets/Group 7557.png' alt=''/> Etherscan</FirstAnchor>
                <Anchors href="#"><CsIcons src='./assets/Path122844.png' alt=''/> Follow Us</Anchors>
                <Anchors href="#"><CsIcons src="./assets/Group46.png" alt=""/> Join Us</Anchors>
            </AnchorWrapper>
        </Tabwrapper>
    );
}

export default Home;